import { useEffect, useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { PlusCircle, Save, Trash2, Power } from "lucide-react";
import { Modal } from "@/pages/Customers";

export default function AdminBranches() {
  const [list, setList] = useState([]);
  const [modal, setModal] = useState(null);
  const [loading, setLoading] = useState(true);

  async function refresh() {
    setLoading(true);
    try {
      const { data } = await api.get("/branches");
      setList(data);
    } catch (e) {
      toast.error(formatApiError(e));
    } finally {
      setLoading(false);
    }
  }
  useEffect(() => { refresh(); }, []);

  async function save() {
    try {
      if (modal.id) {
        await api.patch(`/branches/${modal.id}`, { name: modal.name, address: modal.address, phone: modal.phone });
        toast.success("Sucursal actualizada");
      } else {
        await api.post("/branches", { name: modal.name, address: modal.address, phone: modal.phone });
        toast.success("Sucursal creada");
      }
      setModal(null);
      refresh();
    } catch (e) {
      toast.error(formatApiError(e));
    }
  }

  async function toggle(b) {
    try {
      await api.patch(`/branches/${b.id}`, { active: !b.active });
      refresh();
    } catch (e) { toast.error(formatApiError(e)); }
  }

  async function del(b) {
    if (!confirm(`¿Eliminar ${b.name}?`)) return;
    try { await api.delete(`/branches/${b.id}`); toast.success("Eliminada"); refresh(); }
    catch (e) { toast.error(formatApiError(e)); }
  }

  return (
    <div className="max-w-4xl mx-auto space-y-5">
      <div className="flex items-center justify-between flex-wrap gap-3">
        <div>
          <h1 className="font-heading font-extrabold text-3xl tracking-tight">Sucursales</h1>
          <p className="text-slate-500 text-sm mt-1">Gestión de puntos de servicio.</p>
        </div>
        <button onClick={() => setModal({ name: "", address: "", phone: "" })} className="btn-primary" data-testid="branches-new-button">
          <PlusCircle size={18} /> Nueva sucursal
        </button>
      </div>

      {loading ? <div className="text-slate-500 font-mono">Cargando…</div> : (
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
          {list.map((b) => (
            <div key={b.id} className={`card-base p-4 ${!b.active ? "opacity-60" : ""}`} data-testid={`branch-card-${b.name}`}>
              <div className="flex items-start justify-between gap-2">
                <div className="min-w-0">
                  <div className="font-heading font-bold text-lg">{b.name}</div>
                  {b.address && <div className="text-sm text-slate-500 truncate">{b.address}</div>}
                  {b.phone && <div className="text-xs text-slate-500 font-mono">{b.phone}</div>}
                  <div className={`text-[10px] font-mono uppercase tracking-widest mt-1 ${b.active ? "text-green-600" : "text-red-500"}`}>
                    {b.active ? "Activa" : "Inactiva"}
                  </div>
                </div>
                <div className="flex flex-col gap-1">
                  <button onClick={() => toggle(b)} className="btn-ghost" title={b.active ? "Desactivar" : "Activar"} data-testid={`branch-toggle-${b.name}`}><Power size={16} /></button>
                  <button onClick={() => setModal({ ...b })} className="btn-ghost text-xs" data-testid={`branch-edit-${b.name}`}>Editar</button>
                  <button onClick={() => del(b)} className="btn-ghost text-red-500" data-testid={`branch-delete-${b.name}`}><Trash2 size={16} /></button>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}

      {modal && (
        <Modal onClose={() => setModal(null)} title={modal.id ? "Editar sucursal" : "Nueva sucursal"}>
          <div className="space-y-3">
            <input value={modal.name} onChange={(e) => setModal({ ...modal, name: e.target.value })} placeholder="Nombre" className="input-base" data-testid="branch-modal-name" />
            <input value={modal.address || ""} onChange={(e) => setModal({ ...modal, address: e.target.value })} placeholder="Dirección" className="input-base" data-testid="branch-modal-address" />
            <input value={modal.phone || ""} onChange={(e) => setModal({ ...modal, phone: e.target.value })} placeholder="Teléfono" className="input-base" data-testid="branch-modal-phone" />
            <button onClick={save} className="btn-primary w-full" data-testid="branch-modal-save"><Save size={16} /> Guardar</button>
          </div>
        </Modal>
      )}
    </div>
  );
}
